import { Component, inject, Input, signal, computed } from '@angular/core';
import { SidebarService } from '@app/core/services/sidebar.service';
import { ProfileService, MediaPlatformService } from '@outlaw/core';
import { Location } from '@angular/common';

@Component({
  selector: 'app-community-header',
  templateUrl: './community-header.component.html',
  styleUrls: ['./community-header.component.scss'],
  standalone: false,
})
export class CommunityHeaderComponent {
  @Input() isChatRoute = false;
  @Input() isInternalPage = signal(false);

  /** Show back button below 1700px */
  showBackButton = computed(() => !this.mediaPlatformService.isLargeDesktop());

  isGuest = inject(ProfileService).getUser() === null;
  sidebarService = inject(SidebarService);
  private location = inject(Location);
  private mediaPlatformService = inject(MediaPlatformService);

  showUserMenu = false;

  toggleUserMenu(): void {
    this.showUserMenu = !this.showUserMenu;
  }

  openChatSidebar(): void {
    this.sidebarService.openChatSidebar();
  }

  openMainSidebar(): void {
    this.sidebarService.openMainSidebar();
  }

  goBack(): void {
    this.location.back();
  }
}
